import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["placeholder", "onButtonClick", "buttonLabel", "buttonClassName"];
import React from 'react';
import { Input, Button, createUseStyles } from 'hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
import classnames from 'classnames';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'Text');
function Text(_ref) {
  let {
      placeholder,
      onButtonClick,
      buttonLabel = 'cfm_action_add',
      buttonClassName
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useWeb5Context();
  const onClick = () => {
    onButtonClick && onButtonClick();
  };
  const classes = useStyles();
  const buttonClasses = classnames(classes.button, buttonClassName);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, _extends({
    labelMode: "horizontal",
    placeholder: placeholder || t('cfm_placeholder_type_value')
  }, props)), onButtonClick && /*#__PURE__*/React.createElement("div", {
    className: buttonClasses
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    type: "secondary",
    onClick: onClick
  }, t(buttonLabel))));
}
export default Text;